import React, { Component } from 'react';
import './Credentials.css';
import TextInput from '../subComponents/TextInput';
import Button from '../subComponents/CustomButton';
import { connect } from 'react-redux';
import { receiveBooking, stepMoveBooking, receiveCredentials, stepLoading, stepFailure } from '../../redux';
import * as API from '../../api';

const mapStateToProps = (state) => ({
  bookingCode: state.credentials.bookingCode,
  phone: state.credentials.phone,
  email: state.credentials.email
});

const mapDispatchToProps = (dispatch) => ({
  receiveBooking: (data) => dispatch(receiveBooking(data)),
  stepMoveBooking: () => dispatch(stepMoveBooking()),
  stepLoading: () => dispatch(stepLoading()),
  stepFailure: () => dispatch(stepFailure()),
  receiveCredentials: (body) => dispatch(receiveCredentials(body))
});

export default connect(mapStateToProps, mapDispatchToProps)(class Credentials extends Component {
  constructor(props) {
    super(props);

    this.state = {
      buttonDisabled: true,
      errorMessage: ''
    }
  }

  componentDidMount() {
    // ---------------------- TESTING BUDDY ----------------------
    // const { receiveBooking, stepMoveBooking, receiveCredentials } = this.props;
    // const creds = {
    //   bookingCode: 'CTRLV2K0P18P09I11',
    //   email: 'developer@ctrlv.ca',
    //   phone: ''
    // };
    // API.getMoveBooking(creds.bookingCode, creds.email, creds.phone)
    //   .then(result => {
    //     console.error('Remove this Testing Buddy before pushing to production.');
    //     receiveCredentials(creds);
    //     receiveBooking(result);
    //     stepMoveBooking();
    //   })
    //   .catch(error => {
    //     console.error('Failed to get booking info: ', error);
    //     this.setState({ errorMessage: error });
    //   });
    // -----------------------------------------------------------
  }

  handleChange = name => event => {
    const { bookingCode, email, phone } = this.props;
    let buttonDisabled = true;
    let creds = {
      bookingCode,
      email,
      phone,
      [name]: event.target.value,
    };

    if (this.validate(creds)) buttonDisabled = false;
    else buttonDisabled = true;

    this.setState({
      buttonDisabled,
      errorMessage: ''
    });
    this.props.receiveCredentials(creds);
  }

  validate = creds => {
    const { bookingCode, phone, email } = creds;
    const vcode = (new RegExp('^CTRLV', 'g')).test(bookingCode);
    const vphone = (phone && phone.match(/\d/g)) ? phone.match(/\d/g).length === 10 : false;
    const emailMask = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;
    const vemail = emailMask.test(email);
    return vcode && (vemail || vphone);
  }

  onSubmitClick = () => {
    const { bookingCode, email, phone, receiveBooking, stepMoveBooking } = this.props;

    if (this.validate({ bookingCode, email, phone })) {
      this.setState({ errorMessage: '' });
      API.getMoveBooking(bookingCode, email, phone)
        .then(result => {
          receiveBooking(result);
          stepMoveBooking();
        })
        .catch(error => {
          console.error('Failed to get booking info: ', error);
          this.setState({ errorMessage: error });
        });
    }
  }

  render() {
    return (
      <div className={'Credentials'}>

        <div className={'Credentials-text'}>
          {'This form can be used to move a Ctrl V booking to another date and/or time'} <br/> {'(provided the booking\'s current start time is at least 24 hours from now).'}
          <p></p>
        </div>
        <div className={'Credentials-text'}>
          {'Please enter your booking code, and either your email or phone number associated with your booking.'}
        </div>
        <div>
          <TextInput
            id={'bookingCode'}
            label={'Booking Code'}
            value={this.props.bookingCode}
            onChange={this.handleChange('bookingCode')}
          />
        </div>
        <div>
          <TextInput
            id={'email'}
            label={'Email'}
            value={this.props.email}
            onChange={this.handleChange('email')}
          />
        </div>
        <div>
          <TextInput
            id={'phone'}
            label={'Phone Number'}
            value={this.props.phone}
            onChange={this.handleChange('phone')}
          />
        </div>
        <div>
          <Button
            text={'SUBMIT'}
            icon={'send'}
            onClick={this.onSubmitClick}
            disabled={this.state.buttonDisabled}
          />
        </div>
        <div className={'errorMessage'}>
          {this.state.errorMessage}
        </div>
      </div>
    );
  }
});
